import { useFlags } from "Services/FeatureFlagService";
import { fetchOptions, type OnFetchFulfilledCallback } from "Services/util/fetchInterceptorState";

/**
 * Globally configures fetch interception as long as the feature flag is on. App should consume fetch Ponyfill for this to work.
 * @param onFetchCallback
 */
export function useFetchInterceptor(onFetchCallback: OnFetchFulfilledCallback) {
    const { rolloutUiUnauthorizedInterception } = useFlags();
    fetchOptions.interceptEnabled = rolloutUiUnauthorizedInterception;
    fetchOptions.onFetchCallback = onFetchCallback;
}
